export const SpacesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3911_10778)">
        <path
          d="M3 17L18 17"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 17V3.58333C5 3.42862 5.06438 3.28025 5.17899 3.17085C5.2936 3.06146 5.44903 3 5.61111 3H15.3889C15.551 3 15.7064 3.06146 15.821 3.17085C15.9356 3.28025 16 3.42862 16 3.58333V17"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9375 10.875C13.4553 10.875 13.875 10.4553 13.875 9.9375C13.875 9.41973 13.4553 9 12.9375 9C12.4197 9 12 9.41973 12 9.9375C12 10.4553 12.4197 10.875 12.9375 10.875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3911_10778">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
